import { Pipe, PipeTransform } from '@angular/core';
import { IsNotNullOrEmpty } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { FormatUrlLocation } from '@apply4u/shared/helpers/seo-helper';
@Pipe({
  name: 'SearchByLocationSmartPipe',
  standalone: true
})
export class SearchByLocationSmartPipe implements PipeTransform {
    constructor(){ }
    transform(locationText: string, isJobSearch : boolean) {
      return this.GetJobSearchByLocationUrl(locationText, isJobSearch);
    }

    GetJobSearchByLocationUrl(locationText: string, isJobSearch: boolean) {
      let url = isJobSearch == true ? "/jobs" : "/cv-search";
  
      let formattedLocationText = FormatUrlLocation(locationText);
  
      if (IsNotNullOrEmpty(formattedLocationText)) {
        url += isJobSearch == true ? "/jobs-in" : "/cvs-in";
        url += formattedLocationText;
      }
  
      return url;
    }
}